import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const UserEventTypeCreationDropdown = withSafeSuspense(lazy(async () => ({
  default: (await import('./dropdowns')).UserEventTypeCreationDropdown
})))

export const TeamEventTypeCreationDropdown = withSafeSuspense(lazy(async () => ({
  default: (await import('./dropdowns')).TeamEventTypeCreationDropdown
})))
